module.exports = __webpack_public_path__ + "media/images/emblems/Madulain_wappen-1542d105a24e34a12ddcf2d8e7d6e8ae.svg";